import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Wrapper for Certificate page.
 * - Admin: always allowed
 * - Member: allowed only if can_create_certificate is true
 */
export default function CertificatePermissionGate({ children }) {
  const { user, role } = useAuth();
  const location = useLocation();

  if (role === "admin") {
    return children;
  }

  if (role === "member") {
    const canCreate = user?.can_create_certificate === true;
    if (canCreate) {
      return children;
    }
    return <Navigate to="/member/dashboard" state={{ message: "You do not have permission to create certificates." }} replace />;
  }

  return <Navigate to="/member/login" state={{ from: location }} replace />;
}
